import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('mobility_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('mobility_user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('mobility_user');
    localStorage.removeItem('mobility_token');
  };

  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('mobility_user', JSON.stringify(userData));
  };

  // Re-pull user profile from server (used after activating dual role).
  const refreshUser = async () => {
    try {
      const r = await api.get('/auth/me');
      updateUser(r.data);
      return r.data;
    } catch (e) {
      return null;
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, refreshUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};